/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Avatar, Input, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";
import { fonts } from "../../themes/themes";
import { useTranslation } from "react-i18next";

interface IProfilePicProps {
  profilePic?: string;
  setNewProfilePic: (data: any) => void;
}

const UpdateDepPrPicPresenter = ({
  profilePic,
  setNewProfilePic,
}: IProfilePicProps) => {
  const { t } = useTranslation();
  const trans = t;
  const CustomInput = styled(Input)({
    display: "none",
  });
  const [isUpdate, setIsUpdate] = useState(false);

  const [, setNewProfilePicc] = useState("");
  const [, setNewProfilePicPath] = useState("");

  const handleUpdateProfilePic = (e: any) => {
    const image_as_base64: any = URL.createObjectURL(e.target.files[0]);
    const image_as_files = e.target.files[0];
    setNewProfilePicc(image_as_files);
    setNewProfilePicPath(image_as_base64);
    setNewProfilePic(image_as_files);
  };

  return (
    <Box
      onMouseEnter={() => setIsUpdate(true)}
      onMouseLeave={() => setIsUpdate(false)}
    >
      <Avatar
        src={profilePic}
        style={{
          background: "transparent 0% 0% no-repeat padding-box",
          boxShadow: "0px 3px 6px #00000029",
          border: "3px solid #ffffff",
          opacity: isUpdate ? "0.5" : "1",
          height: "5em",
          width: "5em",
          borderRadius: "50%",
        }}
      />
      {isUpdate && (
        <label htmlFor="icon-button-file">
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: "1",
              opacity: "1",
              marginTop: "-5.5em",
              marginLeft: "0.6em",
              position: "absolute",
            }}
          >
            <CustomInput
              id="icon-button-file"
              type="file"
              onChange={(e: any) => handleUpdateProfilePic(e)}
            />
            <i
              className="las la-camera"
              style={{
                color: "#00000029",
                fontSize: "20px",
                cursor: "pointer",
              }}
            ></i>{" "}
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                fontSize: fonts.title,
                fontWeight: "bold",
                color: "#00000029",
                cursor: "pointer",
              }}
            >
              {trans("Update Photo")}
            </Typography>
          </Box>
        </label>
      )}
    </Box>
  );
};

export default UpdateDepPrPicPresenter;
